import { useRef } from "react";
import emailjs from "@emailjs/browser";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

export const EmailSection = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_63gbx2i",
        "template_kmze74b",
        form.current,
        "Cgb5sCT5pv2YASu6h"
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Email sent, you can close this alert.");
        },
        (error) => {
          console.log(error.text);
          alert(`Error: ${error.text}, please try again.`);
        }
      );
  };

  return (
    <>
      <Form ref={form} onSubmit={sendEmail}>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
          <Form.Label>Name</Form.Label>
          <Form.Control
            required
            type="text"
            placeholder="e.g. Paul"
            name="user_name"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            required
            name="user_email"
            type="email"
            placeholder="name@example.com"
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label>Example textarea</Form.Label>
          <Form.Control required name="message" as="textarea" rows={3} />
        </Form.Group>
        <Button type="submit">Submit</Button>
      </Form>
    </>
  );
};
